
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useProjectView = () => {
  const [activeView, setActiveView] = useState('dashboard');
  const navigate = useNavigate();
  
  // Enhanced setter function to handle both state and navigation
  const setActiveViewWithNavigation = (view: string) => {
    setActiveView(view);
    
    // Map views to routes
    switch (view) {
      case 'dashboard':
        navigate('/');
        break;
      case 'projects':
        navigate('/projects');
        break;
      case 'schedule':
        navigate('/schedule');
        break;
      case 'documents':
        navigate('/documents');
        break;
      case 'reports':
        navigate('/reports');
        break;
      case 'settings':
        navigate('/settings');
        break;
      case 'daily-report':
        navigate('/reports/daily-project');
        break;
      case 'weekly-report':
        navigate('/reports/weekly');
        break;
      case 'monthly-report':
        navigate('/reports/monthly');
        break;
      default:
        navigate('/');
    }
  };
  
  return {
    activeView,
    setActiveView: setActiveViewWithNavigation
  };
};
